import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/_app/manage/pathways/$pathwayId/")({
    loader: ({ params }) => {
        // Simple loader for now - in real app this would fetch pathway data
        return Promise.resolve({ pathwayId: params.pathwayId })
    },
}) 